import React from 'react';
import { StarIcon } from '@heroicons/react/20/solid';
import { CheckBadgeIcon } from '@heroicons/react/24/solid';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import LegardaPNG from '../assets/imgs/profile-legarda-s.png';
import AnilPNG from '../assets/imgs/profile-prof-anil-t.png';
import GarciaPNG from '../assets/imgs/profile-garcia-g.png';
import VernellePNG from '../assets/imgs/profile-vernelle-r.png';
import { CHROME_STORE_REVIEWS_URL } from '../config';


// Source of truth: the Chrome Web Store listing header. Re-check when updating.
const STORE_RATING = '4.7';
const STORE_RATINGS_COUNT = '2.4K+';
const STORE_USERS = '400,000+';

const testimonials = [
  {
    name: 'Legarda S.',
    picture: LegardaPNG,
    message: 'Excellent! So helpful. Thanks for sharing.',
    rating: 5,
  },
  {
    name: 'Prof Anil T.',
    picture: AnilPNG,
    message: `One of the fantastic extension for keeping the meet record I recommend to all those who use
      Google Meet and wish to keep exclusive record for the same, love it`,
    rating: 5,
  },
  {
    name: 'Gracia G.',
    picture: GarciaPNG,
    message: `It allows me, my boss and the parents to monitor my students
      attendance and punctuality in the most accurate and simplest way possible. Thanks to the
      developer. Highly recommended!!!`,
    rating: 5,
  },
  {
    name: 'Vernelle R.',
    picture: VernellePNG,
    message: `Excellent extension, quite helpful to track students attendance for each class.`,
    rating: 5
  },
];

function Rating({ value }) {
  return (
    <>
      <div className="flex items-center text-amber-400" aria-hidden="true">
        {
          Array.from({ length: value }).map((_, index) => (
            <StarIcon key={index} className="w-4 h-4" />
          ))
        }
      </div>
      <span className="sr-only">Rated { value } out of 5</span>
    </>
  );
}

export default function Testimonials() {

  return (
    <section id="testimonials" aria-label="Reviews" className="bg-gray-100 py-16 px-3">
      <div className="container mx-auto">
        <div className="text-blue-600 font-bold text-center">
          Reviews
        </div>
        <h2 className="text-3xl text-center mt-2 mb-8">
          Teachers, professors, and meeting hosts
        </h2>

        <div className="flex justify-center mb-4">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium
                           text-green-700 bg-green-50 border border-green-200">
            <CheckBadgeIcon className="w-4 h-4 mr-1.5" aria-hidden="true" />
            Featured on the Chrome Web Store
          </span>
        </div>

        <dl className="max-w-3xl mx-auto mb-12 bg-white rounded-lg border border-gray-200
                       divide-y divide-gray-200 sm:grid sm:grid-cols-3 sm:divide-y-0 sm:divide-x">
          <div className="flex flex-col-reverse px-6 py-5 text-center">
            <dt className="mt-1 text-sm text-gray-1">Chrome Web Store rating</dt>
            <dd className="flex items-center justify-center text-2xl font-bold text-meet-black">
              { STORE_RATING }
              <StarIcon className="w-5 h-5 ml-1 text-amber-400" aria-hidden="true" />
            </dd>
          </div>
          <div className="flex flex-col-reverse px-6 py-5 text-center">
            <dt className="mt-1 text-sm text-gray-1">ratings</dt>
            <dd className="text-2xl font-bold text-meet-black">{ STORE_RATINGS_COUNT }</dd>
          </div>
          <div className="flex flex-col-reverse px-6 py-5 text-center">
            <dt className="mt-1 text-sm text-gray-1">users</dt>
            <dd className="text-2xl font-bold text-meet-black">{ STORE_USERS }</dd>
          </div>
        </dl>

        <div className="grid gap-6 mb-10 sm:grid-cols-2 lg:grid-cols-4">
          {
            testimonials.map((item) => (
              <figure
                key={`testimonial-${item.name}`}
                className="flex flex-col h-full p-6 bg-white rounded-lg border border-gray-200 shadow-sm"
              >
                <Rating value={item.rating} />
                <blockquote className="mt-4 text-sm leading-relaxed text-gray-600">
                  <p>&ldquo;{ item.message }&rdquo;</p>
                </blockquote>
                <figcaption className="flex items-center gap-3 mt-auto pt-6">
                  <img className="w-9 h-9 rounded-full"
                       src={item.picture}
                       alt="" />
                  <div>
                    <div className="text-sm font-medium text-meet-black">{ item.name }</div>
                    <div className="text-xs text-gray-1">Chrome Web Store</div>
                  </div>
                </figcaption>
              </figure>
            ))
          }
        </div>

        <div className="text-center">
          <a
            className="secondary inline-flex items-center"
            href={CHROME_STORE_REVIEWS_URL}
            target="_blank"
            rel="noreferrer"
          >
            Read all reviews on the Chrome Web Store
            <ArrowRightIcon className="w-4 h-4 ml-2" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
